import { Instagram, Facebook, Youtube } from "lucide-react";
import Logo from "@/components/Logo";

const SOCIALS = [
  { icon: Instagram, href: "https://instagram.com", label: "Instagram" },
  { icon: Facebook, href: "https://facebook.com", label: "Facebook" },
  { icon: Youtube, href: "https://youtube.com", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t-2 border-[#073B4C] bg-[#073B4C] text-white"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
        <div className="text-center md:text-left">
          <div className="bg-white inline-block rounded-2xl px-4 py-2 border-2 border-white">
            <Logo testId="footer-logo" />
          </div>
          <p className="font-body text-sm text-white/60 mt-4 max-w-xs">
            Whimsical coloring books hand made with AI by Wendy. Available now on
            Amazon.
          </p>
        </div>

        <div className="flex flex-col items-center md:items-end gap-4">
          <div className="flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="p-2.5 bg-white/10 border-2 border-white/30 rounded-full hover:bg-[#FFD166] hover:text-[#073B4C] hover:border-[#FFD166] transition-colors"
              >
                <s.icon size={20} />
              </a>
            ))}
          </div>
          <nav className="flex gap-6 font-heading text-sm">
            <a href="#books" className="text-white/70 hover:text-[#FFD166] transition-colors">Books</a>
            <a href="#about" className="text-white/70 hover:text-[#FFD166] transition-colors">About</a>
            <a href="#newsletter" className="text-white/70 hover:text-[#FFD166] transition-colors">Newsletter</a>
          </nav>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-center font-body text-xs text-white/50">
          © {new Date().getFullYear()} Coloring Books by Wendy. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
